import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getGlobalBanner } from './app.reducer';
import { IGlobalBanner } from '../modules/shared/components/global-banner/global-banner.interface';

@Injectable()
export class AppStore {
  globalBanner$: Observable<IGlobalBanner> = this._store.select(
    getGlobalBanner
  );

  constructor(private _store: Store<any>) {}
}
